module.exports = __webpack_public_path__ + "static/img/bg-tab-2.f984d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-tab-2.png
// module id = Szhq
// module chunks = 1